import { Component, ChangeDetectorRef, ElementRef, HostListener, Input, OnInit, OnDestroy, ViewChild, ViewEncapsulation, Optional } from '@angular/core'
import { Subject, takeUntil, Subscription, BehaviorSubject, Observable } from 'rxjs'
import { fadeIn, fadeInOut, mensagemEntrando } from '../animations'
import {SignalrService} from "../../signalr.service"
import {ChatService} from "../chat.service"
import shortUUID from 'short-uuid';
import { environment } from 'environments/environment';
import { MensagemService } from 'app/mensagem.service';
import { ActivatedRoute } from '@angular/router'
import { ImageViewerService } from '../image-viewer/image-viewer.service';

@Component({
  selector: 'chat-widget',
  templateUrl: './chat-widget.component.html',
  animations: [fadeInOut, fadeIn, mensagemEntrando],
  // styleUrls:['./chat-widget.component.css', './chat-widget-v2.component.css'],
  styleUrls:['./chat-widget-v4.component.css'],
  encapsulation: ViewEncapsulation.ShadowDom
})

export class ChatWidgetComponent implements OnInit, OnDestroy {
  @ViewChild('container') container!: ElementRef;
  @ViewChild('bottom') bottom!: ElementRef
  @ViewChild('chatButton') button!: ElementRef
  @ViewChild('chat') set chat(chat: ElementRef) {
    this._chat = chat
  }

  @Input() public theme: 'blue' | 'grey' | 'red' = 'blue';

  @Input() public designModelo: any;
  @Input() public onlineLabel: any;
  @Input() public prechat!: any[];
  @Input() public form: any[] = [{nome: {value: "", required: true, show: true}, email: {value: "", required: true, show: true}}];

  @Input() public fullscreen: boolean = false;

  constructor(private _signalR: SignalrService,
     private _chatService: ChatService,
     private _mensagemService: MensagemService,
     private _changeDetectorRef: ChangeDetectorRef,
     private _imageViewerService: ImageViewerService,
     @Optional() private _route: ActivatedRoute
  ){}

  public limite: boolean = false;
  public boxSpec: any;
  public mouse: any;

  public height: any = 496;
  public right: any;
  public left: any;

  public _chat: any;
  public isEmojiPickerVisible: boolean = false;
  private _visible = false;
  private _visible_bottom = false;

  public mobileFullscreen: boolean = false;

  public mobileViewportHeight: number | null = null;
  public mobileViewportOffsetTop: number = 0;
  public mobileViewportWidth: number | null = null;
  public mobileViewportOffsetLeft: number = 0;

  public ip: string = "";
  public catalogo: string = "";
  private _unsubscribeAll: Subject<any> = new Subject<any>();

  previewMode:boolean = false
  subscription!: Subscription;

  public focus = new Subject()

  public messages : any[] = [];

  public script:any= null;

  public ringNotificacaoCard!: HTMLAudioElement;

  public _IPcarregado: BehaviorSubject<boolean> = new BehaviorSubject(null);

  public habilitarStatusOnline: boolean = true;
  public iniciarChatAberto: boolean = false;

  public chatFinalizado: boolean = false;
  public mensagemGuidFinalizada: string = '';

  public linksRapidos: { legenda: string, url: string }[] = [];
  public mostrarLinks: boolean = false;

  public orientacaoLado: 'right' | 'left' = 'right';
  public orientacaoValor: string = '3%';

  public get offsetLinks(): number {
    return this.designModelo === 'barra' ? 52 : 116;
  }

  get IPcarregado$(): Observable<boolean> {
    return this._IPcarregado.asObservable();
  }

  public recuperandoIp: boolean = true ;
  public signalRIniciando: boolean = true ;
  public cssInjetado: boolean = false;
  public dadosCarregados: boolean = false;

  public get visible() {
    return this._visible
  }

  @Input() public set visible(visible) {
    this._visible = visible
    if (this._visible) {
      setTimeout(() => {
        this.scrollToBottom(true)
        this.focusMessage()
      }, 0)
    }
  }

  public get visible_bottom() {
    return this._visible_bottom
  }

  @Input() public set visible_bottom(visible_bottom) {
    this._visible_bottom = visible_bottom
  }

  private atualizarViewportMobile = () => {
    if (!this.fullscreen && !this.mobileFullscreen) return;

    const visualViewport = window.visualViewport;

    this.mobileViewportHeight = visualViewport
      ? visualViewport.height
      : window.innerHeight;

    this.mobileViewportOffsetTop = visualViewport
      ? visualViewport.offsetTop
      : 0;

    this.mobileViewportWidth = visualViewport
      ? visualViewport.width
      : window.innerWidth;

    this.mobileViewportOffsetLeft = visualViewport
      ? visualViewport.offsetLeft
      : 0;

    this._changeDetectorRef.detectChanges();
  }

  private iniciarViewportMobile() {

    if (!window.visualViewport) return;

    window.visualViewport.removeEventListener(
      'resize',
      this.atualizarViewportMobile
    );

    window.visualViewport.removeEventListener(
      'scroll',
      this.atualizarViewportMobile
    );

    window.visualViewport.addEventListener(
      'resize',
      this.atualizarViewportMobile
    );

    window.visualViewport.addEventListener(
      'scroll',
      this.atualizarViewportMobile
    );

    this.atualizarViewportMobile();
  }

  ngOnInit() {
    if (this.fullscreen && this._route) {
      this._route.queryParamMap.subscribe(params => {
        if (params.has('id') && params.has('message')) {
          this.catalogo = params.get('id')!;
          this._chatService.chatApiUrl = environment.chatApi;
          this._chatService.messages = this.messages;
          this._signalR.guid = params.get('message')!;
        }
      });
    }

    this.verificarAmbiente();

    this.inicializarChat();

    if (this.fullscreen) {
      this._visible = true;
      this._visible_bottom = false;
      this.iniciarViewportMobile();
    }

    this._IPcarregado.subscribe((complete) => {
      if(complete){
        this.recuperandoIp = false
        console.debug("IP OK !")
        if(!this.cssInjetado && this.dadosCarregados){
          setTimeout(()=>{
            this.injetarCss()
          })
        }
      }
    })

    this._signalR.chatFinalizado$.pipe(
      takeUntil(this._unsubscribeAll)).subscribe((finalizado: boolean) => {
        if (finalizado) {
          this.mensagemGuidFinalizada = this._signalR.guid;
        }
        this.chatFinalizado = finalizado
        this._changeDetectorRef.markForCheck()
    })

    this._signalR._mensagemRecebida.subscribe(async (data) =>{
        if(data != null && data > 0){
            if(this.ringNotificacaoCard == null){
              this.ringNotificacaoCard = new Audio();
              this.ringNotificacaoCard.src = this._chatService.appApiUrl +  'assets/audio/chat.mp3';
            }
            try {
              await this.ringNotificacaoCard.play();
            } catch (error) {
              console.log(`erro na execução da notificação - error: ${error}`);
            }

            if(!this.visible && !this.fullscreen){
              this.visible = true
            }
        }
        setTimeout(() =>{
          this.scrollToBottom(data === 0)
        })
    })

    this._signalR._conexaoIniciada.subscribe((complete)=>{
      if(complete){
        if (this.fullscreen && !this.chatFinalizado) {
          this._signalR.enviarMensagem("Conversa iniciada no WebChat Inteliax!", this.ip);
        }
        this.signalRIniciando = false
        console.debug("SIGNALR OK !")
        if(!this.cssInjetado && this.dadosCarregados){
          setTimeout(()=>{
            this.injetarCss()
          })
        }
      }
    })

    this._mensagemService.getIpAddress().then((result) => {
        console.log("Carregado : "  + result);
        this.ip = result;
        this._IPcarregado.next(true)
      });

    setTimeout(()=>{
      if(this.recuperandoIp){
        this._IPcarregado.next(true)
        console.log("Timeout ao Recuperar o IP")
      }
    }, 10000)

this._mensagemService.dadosConfiguracaoChat.pipe( 
  takeUntil(this._unsubscribeAll)).subscribe((dados:any) => { 
    this.dadosCarregados = true 
    this.setDataWebchat(dados); 
    this.injetarCss(); 
    this.visible_bottom = true 

    if (this.iniciarChatAberto && !this.fullscreen &&!window.matchMedia('(max-width: 1024px)').matches) {
      this._visible = true;
      this.mobileFullscreen = false;
      setTimeout(() => {
        this.scrollToBottom(true);
        this.focusMessage();
      }, 0);
    }
  });

    this._mensagemService.dadosMensagem.pipe(
      takeUntil(this._unsubscribeAll)).subscribe((dados:any) => {
        this.messages = this.messages.filter(item => (item.type === 'evento' || item.guid != this._signalR.guid))
        dados.forEach((message: any) => {
          if (message.botoes != null) {
            message.botoes = this._chatService.processarBotoes(message.botoes);
          }
        })
        this.messages = dados.concat(this.messages)

        this.messages = this.messages.sort(function(x, y){
          return x.date - y.date;
        }).reverse();

        this.messages.map((a) => {
          if(a.from.avatar != null && a.from.avatar.startsWith("assets")){
            a.from.avatar = this._chatService.appApiUrl + a.from.avatar
          }
        })

        this._chatService.messages = this.messages;
        this._chatService.menssagemPersistidas = JSON.stringify(this._chatService.messages );

        this.inicializaParticipantes();

        setTimeout(() => {
          this._chatService.chatLoaded = true;
        }, 500)
      }
    )

    this.inicializaParticipantes()
  }

  ngOnDestroy() {
    if (!window.visualViewport) return;

    window.visualViewport.removeEventListener(
      'resize',
      this.atualizarViewportMobile
    );

    window.visualViewport.removeEventListener(
      'scroll',
      this.atualizarViewportMobile
    );
  }

  ngDoCheck() {
    if(this.previewMode){
      if(this.script != null){
        if(this.script.getAttribute('objConfiguracao') != null){
          setTimeout(() => {
            var obj = JSON.parse(this.script.getAttribute('objConfiguracao'))
            this.setDataWebchat(obj);
          },1000)
        }
      }
    }
  }

  inicializaParticipantes(){
    let find = this.messages.find(item => item.type === 'received')
    if(find != null){
      console.log("Encontrou mensagem do operador:", find.from);
      this._chatService.operator.name = find.from.name
      this._chatService.operator.avatar = find.from.avatar
    }
    else{
      this._chatService.resetOperator()
    }
    this._chatService.sistema.avatar = this._chatService.logoPadrao

    console.log("Operador:", this._chatService.operator);
  }

  verificarAmbiente(){

    if (this.fullscreen) {
      return;
    }

    if(environment.production ||  environment == null){
      this.script = document.currentScript
      var scriptSrc = document.currentScript.getAttribute('src').split("widget/")
      this._chatService.chatApiUrl = scriptSrc[0];
      this.catalogo = scriptSrc[1];

      if(document.currentScript.getAttribute('preview') != null){
        this.previewMode = document.currentScript.getAttribute('preview')  == 'true';
        console.log("Modo Preview habilitado ! 😎💻")

        if(document.currentScript.getAttribute('objConfiguracao') != null && document.currentScript.getAttribute('objConfiguracao') != ""){
          var obj = JSON.parse(document.currentScript.getAttribute('objConfiguracao'))
          this.setDataWebchat(obj);
        }

      }
    }
    else{
      this._chatService.chatApiUrl = environment.chatApi
      this.catalogo = environment.catalogo
    }
    this._chatService.messages = this.messages;
  }

  inicializarChat(){
    if(!this.previewMode){
      this._mensagemService.getToken(this._chatService.chatApiUrl,this.catalogo)
      .subscribe( (response) => {
        this._signalR.token = response.accessToken;
        if (!this.fullscreen) {
          this.preservarVariaveis();
        }
        else {
          this.generateSignalRKey();
        }

        this._mensagemService.getRecursoHabilitado(this._chatService.chatApiUrl,this._signalR.chaveSignalR, this._signalR.token)
        .subscribe((res) =>{
          this._chatService.operator.status = res;
        });

        this._mensagemService.getDadosConfiguracaoChat(this._chatService.chatApiUrl,this.catalogo,this._signalR.chaveSignalR,this._signalR.token)
        .subscribe(() => {
          if(this._signalR.guid != "" ){
            this._mensagemService.getMensagens(this._chatService.chatApiUrl,this._signalR.chaveSignalR, this._signalR.guid, this._signalR.token)
            .subscribe( () =>{
              this.iniciaConexaoSignalR();
            },
            err => {
              if(err.status == 400 && err.error.mensagem == 'Mensagem já finalizada .' ){
                  this._mensagemService._dadosMensagem.next(err.error.partes);
                  this._signalR.finalizarChat()
                  this.iniciaConexaoSignalR();
              }
              else if(err.status == 404){
                  console.error(`Guid Inexistente na Base :${JSON.stringify(err)}`);
                  this.iniciaConexaoSignalR();
              }
              else{
                  console.error(`Ocorreu um erro durante o GET de MENSAGENS do Chat:${JSON.stringify(err)}`);
              }
            });
          }
          else{
            this.iniciaConexaoSignalR();
          }
        } ,
        err => {
            console.error("falha ao carregar o Widget: " + err)
        });
      });
    }
    else{
      this.visible_bottom = true;
      this.recuperandoIp = false;
      this.signalRIniciando = false;
    }
  }

  injetarCss(){
    try{
      let link = document.createElement('link');
      link.href = `${this._chatService.chatApiUrl}css/${this.catalogo}/${this._signalR.token}`;
      link.rel = 'stylesheet';
      link.type = 'text/css';

      this.container.nativeElement.append(link)
      this.cssInjetado = true
    }
    catch{
      this.cssInjetado = false
    }
  }

  preservarVariaveis(){
    if(this._signalR.guid == ""){
      this.resetarVariaveis();
    }

    if(this._chatService.expTime == null || this._chatService.expTime == "" ){
      var obj = { exp: Date.now() }
      this._chatService.expTime = JSON.stringify(obj);
    }
    else{
      let Data = new Date(JSON.parse(this._chatService.expTime).exp);
      Data.setHours(Data.getHours() + 24);

      if( Data < new Date(Date.now()) ){
        this.resetarVariaveis();
      }

    }

    if(this._chatService.menssagemPersistidas != null && this._chatService.menssagemPersistidas != ""){
      this.messages = JSON.parse(this._chatService.menssagemPersistidas);
      this.messages.forEach(message => {
        if (message.botoes != null) {
          message.botoes = this._chatService.processarBotoes(message.botoes);
        }
      })
      this._chatService.messages = this.messages;
    }

    if(this._signalR.chatId == null || this._signalR.chatId == ""){
      this._signalR.chatId = shortUUID.generate().substring(1,11)
    }
    this._signalR.chaveSignalR = this._signalR.chatId + '@' + this.catalogo;
  }

  generateSignalRKey(){
    if(this._signalR.chatId == null || this._signalR.chatId == ""){
      this._signalR.chatId = shortUUID.generate().substring(1,11)
    }
    this._signalR.chaveSignalR = this._signalR.chatId + '@' + this.catalogo;
  }

  resetarVariaveis(){
    this._chatService.menssagemPersistidas = "";
    this._signalR.mensagemIniciada = false;
    this._signalR.pergunta = false;
    this._signalR.guid = "";
  }

  iniciaConexaoSignalR(){
    this._signalR.startConnection(this._chatService.chatApiUrl);
    this._signalR.addmensagemIndividualListener();
    this._signalR.addmensagemTodosListener();
    this._signalR.addverificarChatAtivoListener();
    this._signalR.addMensagensNotifyListener();
    this._signalR.addMensagensTipadasNotifyListener();
    this._signalR.addInicioMensagemCompletoListener();
    this._signalR.addDisconnect();
    this._signalR.addReconnected();
  }

  public setDataWebchat(webchat: any){
    this.designModelo = webchat.deisgnModelo
    this.onlineLabel = webchat.onlineLabel
    this.prechat = webchat.prechat
    this._signalR.mensagemSaudacao = webchat.widgetFormText
    this.habilitarStatusOnline = webchat.habilitarStatusOnline;
    this.iniciarChatAberto = webchat.iniciarChatAberto ?? false;

    this._chatService.logoUrl = webchat.logoUrl ?? ""
    if (this._chatService.operator.name === "") {
      this._chatService.resetOperator()
    }

    this.linksRapidos = this.montarLinksRapidos(webchat.linksRapidos)
    this.aplicarOrientacao(webchat.designOrientacao)
  }

  private aplicarOrientacao(orientacao: any) {
    const bruto = (typeof orientacao === 'string' && orientacao.trim() !== '')
      ? orientacao
      : 'right: 3%'

    const partes = bruto.split(':')
    this.orientacaoLado = partes[0].trim().toLowerCase() === 'left' ? 'left' : 'right'
    this.orientacaoValor = (partes[1] ?? '3%').trim().replace(';', '')
  }

  private montarLinksRapidos(bruto: any): { legenda: string, url: string }[] {
    if (bruto == null || !Array.isArray(bruto)) {
      return []
    }

    return bruto.map((item: any) => {
      try {
        const obj = typeof item === 'string' ? JSON.parse(item) : item
        if (obj?.legenda && obj?.url) {
          return { legenda: obj.legenda, url: obj.url }
        }
      } catch {
        console.warn('Link rapido ignorado (JSON invalido):', item)
      }
      return null
    }).filter(item => item != null)
  }

  public abrirLinkRapido(link: { legenda: string, url: string }) {
    window.open(link.url, '_blank', 'noopener,noreferrer')
  }

  public onComposerChange() {
    setTimeout(() => {
      this.scrollToBottom(true)
    }, 0)
  }

  public scrollToBottom(forcar: boolean = false) {
    if (this.bottom === undefined) {
      return
    }

    if (!forcar && !this.estaProximoDoFim()) {
      return
    }

    const lista = this.bottom.nativeElement.parentElement

    if (lista == null) {
      return
    }

    lista.scrollTo({
      top: 0,
      behavior: 'smooth'
    })
  }

  private estaProximoDoFim(): boolean {
    const lista = this.bottom?.nativeElement?.parentElement
    if (lista == null) {
      return true
    }
    return Math.abs(lista.scrollTop) <= 80
  }

  private static readonly MESES = [
    'jan', 'fev', 'mar', 'abr', 'mai', 'jun',
    'jul', 'ago', 'set', 'out', 'nov', 'dez'
  ];

  public formatarData(valor: any): string {
    const data = new Date(valor)
    if (isNaN(data.getTime())) {
      return ''
    }

    const hora = `${this.doisDigitos(data.getHours())}:${this.doisDigitos(data.getMinutes())}`
    const hoje = new Date()

    if (this.mesmoDia(data, hoje)) {
      return hora
    }

    const ontem = new Date(hoje)
    ontem.setDate(ontem.getDate() - 1)
    if (this.mesmoDia(data, ontem)) {
      return `Ontem ${hora}`
    }

    const dia = `${data.getDate()} ${ChatWidgetComponent.MESES[data.getMonth()]}`

    if (data.getFullYear() === hoje.getFullYear()) {
      return `${dia}, ${hora}`
    }
    return `${dia} ${data.getFullYear()}, ${hora}`
  }

  private mesmoDia(a: Date, b: Date): boolean {
    return a.getFullYear() === b.getFullYear()
      && a.getMonth() === b.getMonth()
      && a.getDate() === b.getDate()
  }

  private doisDigitos(n: number): string {
    return n < 10 ? `0${n}` : `${n}`
  }

  public trackMensagem(index: number, message: any) {
    return `${message?.id}|${message?.guid}|${message?.date}`
  }

  public focusMessage() {
    this.focus.next(true)
  }

  public toggleChat() {
    if (this.fullscreen) return;

    this.visible = !this.visible

    if (this.visible) {
      this.mobileFullscreen = window.matchMedia('(max-width: 1024px)').matches;

      if (this.mobileFullscreen) {
        this.iniciarViewportMobile();
      }

      this.button?.nativeElement?.setAttribute("ativo", "true")

      if(this.messages.length == 0){
        setTimeout(()=>{
          this._signalR.enviarMensagemSaudacao()
        }, 500)
      }
    }
  }

  public onChatAnimationDone(event: any) {
    if (!this.visible) {
      this.mobileFullscreen = false;
    }
  }

  public async sendMessage({ message }) {
    if (/^\s+$/.test(message) || message == "" || message == null) {
      return
    }

    if(typeof message == 'string'){
      if(!this.previewMode){

        if(this._signalR.guid == ""){
          this.preservarVariaveis();
          this._signalR.iniciarMensagem(message, this.ip);
        }
        else{
          this._signalR.enviarMensagem(message, this.ip) ;
        }
      }
    }
    else{
      this._mensagemService.postAnexo(this._chatService.chatApiUrl,this._signalR.chaveSignalR, message, this._signalR.guid, this._signalR.token)
      .subscribe((response) => {
        if (response != undefined) {
          message.urlArquivo = response.url
          message.urlThumbnail = response.thumbnails
        }
      }, err => {
        var mensagemErro;
        if (err.status == 413) {
          mensagemErro = err.error.mensagem;
        }
        else if (err.status == 507) {
          mensagemErro = "Não foi possível enviar o arquivo no momento. Tente novamente mais tarde.";
        }
        else if (err.status == 400) {
          mensagemErro = err.error?.mensagem ?? "A conversa precisa estar inicializada";
        }
        else {
          mensagemErro = "falha ao realizar o upload";
        }

        this._chatService.addMessage(this._chatService.client, null, 0, this._signalR.guid, 0,  true, {
          size: err.error?.tamanho ?? message.size ?? 0,
          type: err.error?.contentType ?? message.type ?? "",
          name: err.error?.nomeArquivo ?? message.name ?? "",
          falha: mensagemErro
      })
        this._changeDetectorRef.markForCheck();
      });
    }
  }

  public callResizeChat(e: any){
    if(e == undefined){ return }
    else{
      this.resizeChat(this._chat, e)
    }
  }

  public resizeChat(chat: any, e?){
    if (this.fullscreen) return;

    const { bottom,left, top, right} = chat.nativeElement.getBoundingClientRect();
    this.boxSpec = {bottom,left, top, right}
    var x = e.clientX - this.boxSpec.right
    var y = e.clientY - this.boxSpec.top

    this.mouse = {x, y}
  }

  redimensionar(e){
    if (this.fullscreen) return;

    if(e == false){return this.left = window.innerWidth - 385}
    if(e == true){return this.height = window.innerHeight - 40;}

    if(e.y != 0){

      this.height = (window.innerHeight - e.y) + this.mouse.y
      this.left = e.x - (336 - Math.abs(this.mouse.x))

      if(this.height <= 360){
        this.height = 360;
      }
      if(this.height >=  window.innerHeight - 40){
        this.height =  window.innerHeight - 40;
      }

      if(this.left <= 40){
        this.left = 40;
      }
      if(this.left >= window.innerWidth - 385){
        this.left = window.innerWidth - 385;
      }

    }
  }

  OnClickAnexo(ev:any,message){
    if (message.anexoConteudo.urlArquivo == undefined) {
      return;
    }

    if (
      this.fullscreen &&
      message.anexoConteudo.type.startsWith('image')
    ) {
      this._imageViewerService.open({
        url: message.anexoConteudo.urlArquivo,
        name: message.anexoConteudo.name,
        type: message.anexoConteudo.type
      });
      return;
    }

    this.download(
      message.anexoConteudo.type,
      message.anexoConteudo.urlArquivo,
      message.anexoConteudo.name
    );
  }

  download(type, url, filename) {
    const nomeArquivo = this.getNomeAnexo(filename) || decodeURIComponent(url.split('?')[0].split('/').pop());

    fetch(url, { cache: 'no-cache' })
      .then(resposta => {
        if (!resposta.ok) {
          throw new Error(`Falha ao baixar arquivo: ${resposta.status}`);
        }
        return resposta.blob();
      })
      .then(blob => {
        const urlBlob = URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = urlBlob;
        a.download = nomeArquivo;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        URL.revokeObjectURL(urlBlob);
      })
      .catch(() => window.open(url, '_blank', 'noopener'));
  }

  formataBytes(a,b=2){if(!+a)return"0 Bytes";const c=0>b?0:b,d=Math.floor(Math.log(a)/Math.log(1024));return`${parseFloat((a/Math.pow(1024,d)).toFixed(c))} ${["Bytes","KB","MB","GB","TB","PB","EB","ZB","YB"][d]}`}

  @HostListener('document:keypress', ['$event'])
  handleKeyboardEvent(event: KeyboardEvent) {
    if (event.key === '/') {
      this.focusMessage()
    }
    if (event.key === '?' && !this._visible) {
      this.toggleChat()
    }
  }

  @HostListener('window:resize', ['$event'])
  onResize(event) {
    if (this.fullscreen) return;

    if(this.left > (window.innerWidth - 385)){
        this.redimensionar(false)
    }
    if(this.height > (window.innerHeight - 40))
    {
        this.redimensionar(true)
    }
  }

  getNomeAnexo(nome: string): string {
    return nome.split('/')[nome.split('/').length-1];
  }

  getExtensaoAnexo(nome: string): string {
    const nomeArquivo = this.getNomeAnexo(nome ?? '');
    const indicePonto = nomeArquivo.lastIndexOf('.');

    if (indicePonto === -1 || indicePonto === nomeArquivo.length - 1) {
      return '';
    }

    return nomeArquivo.substring(indicePonto + 1).toLowerCase();
  }

  /**
   * A miniatura e gravada pelo worker alguns segundos depois do upload.
   * Enquanto nao existe, a url assinada responde erro: tenta de novo e,
   * esgotadas as tentativas, cai no icone estatico da extensao
   */
  public recarregarThumb(evento: Event, anexo: any): void {
    const img = evento.target as HTMLImageElement

    if (img.dataset['thumbIcone'] === '1') {
      return
    }

    const tentativas = Number(img.dataset['thumbRetry'] || 0)

    if (!anexo?.urlThumbnail || tentativas >= 6) {
      img.dataset['thumbIcone'] = '1'
      img.src = this.getThumbnailAnexo(anexo?.name)
      return
    }

    img.dataset['thumbRetry'] = String(tentativas + 1)

    setTimeout(() => {
      img.removeAttribute('src')
      requestAnimationFrame(() => { img.src = anexo.urlThumbnail })
    }, (tentativas + 1) * 1000)
  }

  public getThumbnailAnexo(nomeArquivo: string): string {
    const nome = (nomeArquivo ?? '').toLowerCase()
    const extensao = nome.includes('.')
      ? nome.split('.').pop()?.toUpperCase()
      : ''

    const extensoesPermitidas = [
      'AI',
      'AVI',
      'CSS',
      'CSV',
      'DLL',
      'DOC',
      'DOCX',
      'EPS',
      'EXE',
      'GIF',
      'HTML',
      'JPG',
      'JS',
      'MOV',
      'MP3',
      'MP4',
      'PDF',
      'PHP',
      'PNG',
      'PPT',
      'PSD',
      'RAR',
      'RAW',
      'SVG',
      'TXT',
      'URL',
      'WAV',
      'WMV',
      'XLS',
      'XLSX',
      'XML',
      'ZIP'
    ]

    let arquivoThumbnail = 'arquivo.jpeg'

    if (extensao && extensoesPermitidas.includes(extensao)) {
      if (extensao === 'DOCX') {
        arquivoThumbnail = 'DOC.jpeg'
      }
      else if (extensao === 'XLSX') {
        arquivoThumbnail = 'XLS.jpeg'
      }
      else if (extensao === 'URL' || extensao === 'XML') {
        arquivoThumbnail = `${extensao}.png`
      }
      else {
        arquivoThumbnail = `${extensao}.jpeg`
      }
    }

    const caminhoThumbnail = `assets/images/thumbnail/${arquivoThumbnail}`

    if (this.fullscreen || !environment.production) {
      return caminhoThumbnail
    }

    return `${this._chatService.appApiUrl}${caminhoThumbnail}`
  }

  avaliarPrechat(){
    if (this.chatFinalizado) {
      return false
    }
    return (this.messages.length == 0 || this._signalR.guid == "")
  }

}
